import React, { useCallback, useState } from "react";
import TabsContext, { defaultContext } from "../tabs-context";
import { IProps } from "./tabs-provider.types";

/**
 * Container for tabs components.
 */
const TabsProvider: React.FunctionComponent<IProps> = ({ children, activeTabId: initialActiveTabId }) => {
    const [activeTabId, setActiveTabId] = useState(initialActiveTabId);
    const [tabIds, setTabIds] = useState(defaultContext.tabIds);

    /**
     * Register a tab.
     * @param tabId Identifier for the tab being registered.
     */
    const addTab = useCallback((tabId: string): void => {
        setTabIds((tabIds) => [...tabIds, tabId]);
    }, []);

    /**
     * Update the active tab.
     * @param activeTabId The tab to activate.
     */
    const setTab = (activeTabId: string): void => {
        setActiveTabId(activeTabId);
    };

    return (
        <TabsContext.Provider value={{ ...defaultContext, activeTabId, addTab, setTab, tabIds }}>
            {children}
        </TabsContext.Provider>
    );
};

export default TabsProvider;
